module.exports = __webpack_public_path__ + "static/media/arrow_down_red.9ad15174.svg";